import replaceNewline from '../../../functions/replaceNewline'

const EditEventFormPrintCoverLetter = ({eventData}) => {
    if(eventData.hasOwnProperty('cover_letter') && eventData.cover_letter) {
        return <div className="margin-bottom-triple text-small-light" dangerouslySetInnerHTML={{__html: replaceNewline(eventData.cover_letter)}}/>
    } else {
        return ''
    }
}

export default EditEventFormPrintCoverLetter